import { computed } from 'vue';
import {
  EDIT_SYNC_STATUS,
  MESSAGE_STATUS,
  MESSAGE_TYPES,
} from 'next/message/constants';

const pickKey = (object, snakeKey, camelKey) => {
  const source = object || {};
  return source[camelKey] ?? source[snakeKey];
};

export const getTelegramVideoNoteFileId = (message = {}) => {
  const contentAttributes =
    message.contentAttributes ?? message.content_attributes ?? {};
  const contentMediaType = pickKey(
    contentAttributes,
    'telegram_media_type',
    'telegramMediaType'
  );
  const contentFileId = pickKey(
    contentAttributes,
    'telegram_file_id',
    'telegramFileId'
  );

  if (contentMediaType === 'video_note' && contentFileId) {
    return contentFileId;
  }

  const attachments = message.attachments ?? [];
  const videoNoteAttachment = attachments.find(attachment => {
    const meta = attachment.meta ?? {};
    const mediaType =
      pickKey(attachment, 'telegram_media_type', 'telegramMediaType') ??
      pickKey(meta, 'telegram_media_type', 'telegramMediaType');

    return mediaType === 'video_note';
  });

  if (!videoNoteAttachment) return '';

  const meta = videoNoteAttachment.meta ?? {};
  return (
    pickKey(videoNoteAttachment, 'telegram_file_id', 'telegramFileId') ??
    pickKey(meta, 'telegram_file_id', 'telegramFileId') ??
    ''
  );
};

export const useContextMenuOptions = (props, isMessageDeleted) => {
  return computed(() => {
    const hasText = !!props.content;
    const hasAttachments = !!(
      props.attachments && props.attachments.length > 0
    );

    const isOutgoing = props.messageType === MESSAGE_TYPES.OUTGOING;
    const isFailedOrProcessing =
      props.status === MESSAGE_STATUS.FAILED ||
      props.status === MESSAGE_STATUS.PROGRESS;

    const isScheduled = props.status === MESSAGE_STATUS.SCHEDULED;
    const hasTelegramVideoNoteFileId = !!getTelegramVideoNoteFileId(props);

    const hasValidTextSourceId =
      hasText && !isScheduled ? !!props.sourceId : true;

    const hasValidAttachmentsSourceId =
      hasAttachments && !isScheduled
        ? props.attachments.every(att => !!att?.sourceId)
        : true;

    const isLegacySafe =
      props.private || (hasValidTextSourceId && hasValidAttachmentsSourceId);

    const canModify =
      !isMessageDeleted.value ||
      props.editsSyncStatus === EDIT_SYNC_STATUS.FAILED;

    return {
      copy: hasText,
      copyVideoNoteFileId: hasTelegramVideoNoteFileId && !isFailedOrProcessing,
      cannedResponse: isOutgoing && hasText && !isMessageDeleted.value,
      copyLink: !isFailedOrProcessing,
      translate: !isFailedOrProcessing && !isMessageDeleted.value && hasText,
      replyTo:
        !props.private &&
        props.inboxSupportsReplyTo.outgoing &&
        !isFailedOrProcessing,
      edit:
        (hasText || hasAttachments) &&
        props.inboxSupportsMessageEdit &&
        isOutgoing &&
        !isFailedOrProcessing &&
        canModify &&
        isLegacySafe &&
        !hasTelegramVideoNoteFileId,
      delete:
        (hasText || hasAttachments) &&
        isOutgoing &&
        !isFailedOrProcessing &&
        canModify &&
        isLegacySafe,
      sendNow: isScheduled,
      changeSendTime: isScheduled,
    };
  });
};
